var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.LoadingText)?_c('span',[_vm._v("Carregando informações")]):_vm._e(),_c('div',{staticClass:"dot-pulse"})])}
var staticRenderFns = []

export { render, staticRenderFns }